import React, { ReactElement } from 'react';
import 'antd/dist/antd.css';
import { Col, Modal, Row, Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import FormTextArea from '../crmFormElement/FormTextArea/FormTextArea';
import { setDelayedAdmission, updateDefaultTimeline } from '../../../store/actions/newAdmissionAction';
import { GUTTOR_SPACE } from '../../constants/commonConstants';
import { RootState } from '../../../store';

const DelayedIntimationPopUP = (props: any): ReactElement => {
  const {form, setVisible, visible, onCancel} = props;
  const dispatch = useDispatch();
  const defaultTimeline = useSelector((state: RootState): any => state?.newAdmission?.defaultTimeline || {});
  const cancelHandler = (): any => {
    dispatch(setDelayedAdmission(false));
    form.setFieldsValue({ dateOfAdmission: null });
    form.setFieldsValue({ stayLength: null });
    defaultTimeline.remarks['Remarks for delayed intimation'] = undefined;
    dispatch(updateDefaultTimeline(defaultTimeline));
    setVisible(false);
    form.resetFields(['delayedAdmissionRemark']);
    onCancel();
  };
  const onOkHandler = (): any => {
    form.validateFields(['delayedAdmissionRemark'])
    .then((): any => {
      defaultTimeline.remarks['Remarks for delayed intimation'] = (form.getFieldsValue(['delayedAdmissionRemark'])?.delayedAdmissionRemark);
      dispatch(updateDefaultTimeline(defaultTimeline));
      setVisible(false);
    });
  };

  return (
    <Modal
      title="Delay in Intimation"
      centered={true}
      visible={visible}
      onOk={onOkHandler}
      onCancel={cancelHandler}
      okText="Add"
      cancelText="Cancel"
    >
    <Space direction="vertical">

      <Row gutter={GUTTOR_SPACE}>
        <Col md={24}>
          Your current input date greater than DOA. So for that you are requested to
          provide the justification for delay in intimation. Please enter the
          remarks and click add
        </Col>
      </Row>
      <Row gutter={GUTTOR_SPACE}>
        <Col md={24}>
          Or else click on cancel and change the DOA
        </Col>
      </Row>
      <Row gutter={GUTTOR_SPACE}>
        <FormTextArea detail={{
          ...props,
          size: 24,
          key: 'delayedAdmissionRemark',
          hideLabel: false,
        }} />
      </Row>
      </Space>
    </Modal>
  );
};

export default DelayedIntimationPopUP;
